import { render, staticRenderFns } from "./SignalRulesTable.vue?vue&type=template&id=3b42d1d7&scoped=true"
import script from "./SignalRulesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SignalRulesTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SignalRulesTable.vue?vue&type=style&index=0&id=3b42d1d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b42d1d7",
  null
  
)

export default component.exports